/**
 * [ File :: G_Tick.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/frame/G_Tick.js
 * @목적 : 그리드타입 게임에서 사용하는 Tick
 * @진행 : 종료
 * @주의 : 새로운 타입이 생길 때마다 우선순위를 "G_Define"에 설정해줘야합니다.
 * @일자 : 2018.mm.dd
 * @작성 : created by SDM
 * @참조 :
 */

import B_Define from 'canvas/base/dev/util/B_Define'
import G_Define from 'canvas/grid/dev/util/G_Define'

const G_Tick = (function(){

	return class {

		/**
		 * [ Function (public - static) :: tickSwal ]
		 *
		 * @DES :: 타입별 우선순위 정렬처리
		 * @IP1 :: world {obj}
		 * @O.P :: null
		 */
		static tickSwal(world) {

			// [#] 정렬기준
			// G_Define.ORDER;

			world.children.forEach((v) => {
				if(v.type == B_Define.GRID_TYPE) {
					v.children.sort(function(a, b) {
						try {
							if (a.type != b.type) {
								let orderA = G_Define.ORDER.indexOf(a.type);
								let orderB = G_Define.ORDER.indexOf(b.type);
								orderA = orderA == -1 ? G_Define.ORDER.length : orderA;
								orderB = orderB == -1 ? G_Define.ORDER.length : orderB;
								return orderA - orderB;
							}
							else {
								return a.y - b.y;
							}
						} catch (e) { }
					});
				}
			});
		}

		static valueShowing (world) {
			if (typeof world.CODMOS.WRAPPER.interpreter === 'undefined') return

			const IS_RUN = world.CODMOS.WRAPPER.interpreter.status !== 0

			Object.values(world.LIST['getItem']).forEach(e => {
				if (typeof e._valueObj !== 'undefined') {
					e._valueObj.text = IS_RUN !== true && e._isRandom === true ? '?' : e._value
				}
			})
		}

		/**
		 * [ Function :: tickVariableReload ]
		 *
		 * @DES :: 변수 실시간 처리
		 * @IP1 :: world {object}
		 * @O.P :: null
		 */
		static tickVariableReload (world) {
			Object.values(world.LIST['variable']).forEach(e => {
				const VARIABLE = world.LIST[G_Define.VARIABLE_REAL_TYPE][e.variable]
				if (typeof VARIABLE !== 'undefined') e.value = VARIABLE.value
			})
		}

	}
}());
export default G_Tick;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/frame/G_Tick.js